import React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import { ConceptCategoryStore } from '@seedlang/stores';
import InPlaceSelect from 'components/form/in_place_select';
import { isPresent } from '@seedlang/utils';
import { flexLeft } from '@seedlang/style_mixins';
import styled from '@emotion/styled';
import ButtonPrimary from 'components/button/button_primary';

const Wrapper = styled.div`
  ${flexLeft()}
`;

@observer
class ConceptCategoryCreate extends React.Component {
  @observable selectedDeckRulebookId;

  @computed get deckRulebookId() {
    return this.selectedDeckRulebookId || this.defaultDeckRulebookId;
  }

  @computed get defaultDeckRulebookId() {
    if (isPresent(this.props.deckRulebooks)) {
      const defaultRulebook = this.props.deckRulebooks.find(item => item.default);
      if (isPresent(defaultRulebook)) {
        return defaultRulebook.id;
      }
    } return null;
  }

  onClick() {
    ConceptCategoryStore.create({data: {
      name: this.refs.name.value,
      deck_rulebook_id: this.deckRulebookId,
    }}, this.props.callback);
    this.refs.name.value = '';
  }

  render() {
    return (
      <Wrapper className='concept-category-create'>
        <input
          placeholder={this.props.placeholder || 'Add a name'}
          ref='name'
        />
        {
          this.props.deckRulebooks &&
            <InPlaceSelect
              value={this.deckRulebookId}
              options={this.props.deckRulebooks.map(item => [item.id, item.name])}
              onChange={id => this.selectedDeckRulebookId = id}
            />
        }
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          Create
        </ButtonPrimary>
      </Wrapper>
    );
  }
}

export default ConceptCategoryCreate;
